/**
 * Stepper - Fortschrittsanzeige für mehrstufige Prozesse
 *
 * PR-7: Legacy Parity (Gaps 28-30)
 * - Labels hidden auf Mobile (sm:block)
 * - Connector h-1 mit festen Breiten
 * - Farben slate-* statt gray-*
 */

import { Check } from 'lucide-react';

interface StepperProps {
  steps: string[];
  currentStep: number;
  className?: string;
}

export function Stepper({ steps, currentStep, className = '' }: StepperProps) {
  return (
    <div className={`flex items-center justify-between px-4 py-3 bg-flaeche border-b ${className}`}>
      {steps.map((label, index) => (
        <div key={label} className="flex items-center">
          {/* Step Circle */}
          <div className="flex flex-col items-center">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-colors ${
                index < currentStep
                  ? 'bg-lauf text-akzent-satz'
                  : index === currentStep
                    ? 'bg-akzent text-akzent-satz'
                    : 'bg-flaeche-2 text-tinte-3'
              }`}
            >
              {index < currentStep ? <Check className="w-4 h-4" /> : index + 1}
            </div>
            {/* Gap 28: Labels hidden on mobile, visible from sm: */}
            <span
              className={`text-xs mt-1 hidden sm:block max-w-[80px] text-center truncate ${
                index === currentStep ? 'font-medium text-tinte' : 'text-tinte-3'
              }`}
            >
              {label}
            </span>
          </div>

          {/* Gap 29: Connector Line - feste Breiten wie Legacy */}
          {index < steps.length - 1 && (
            <div
              className={`w-8 sm:w-12 lg:w-16 h-1 mx-1 sm:mx-2 rounded transition-colors ${
                index < currentStep ? 'bg-lauf' : 'bg-flaeche-2'
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
}
